import type { Route } from '@angular/router';
import { platformAdminGuard } from './common/guards/platform-admin.guard';
import { CustomerDetailComponent } from './layouts/internal/components/customer-detail/customer-detail.component';
import { CustomerOnboardingComponent } from './layouts/internal/components/customer-onboarding/customer-onboarding.component';
import { CustomersListComponent } from './layouts/internal/components/customers-list/customers-list.component';
import { DashboardComponent } from './layouts/internal/components/dashboard/dashboard.component';
import { LicenseLookupComponent } from './layouts/internal/components/license-lookup/license-lookup.component';
import { QaOverridesComponent } from './layouts/internal/components/qa-overrides/qa-overrides.component';
import { PlatformAdminsListComponent } from './layouts/internal/components/platform-admins-list/platform-admins-list.component';
import { InternalLayoutComponent } from './layouts/internal/internal-layout.component';
import { SplashComponent } from './layouts/external/splash/splash.component';

export const appRoutes: Route[] = [
  {
    path: 'welcome',
    component: SplashComponent,
  },
  {
    path: '',
    component: InternalLayoutComponent,
    canActivate: [platformAdminGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { headerTitle: 'Dashboard' },
      },
      {
        path: 'customers',
        component: CustomersListComponent,
        data: { headerTitle: 'Customers' },
      },
      {
        path: 'customers/new',
        component: CustomerOnboardingComponent,
        data: { headerTitle: 'Onboard Customer' },
      },
      {
        path: 'customers/:id',
        component: CustomerDetailComponent,
        data: { headerTitle: 'Customer' },
      },
      {
        path: 'qa-overrides',
        component: QaOverridesComponent,
      },
      {
        path: 'licensing',
        component: LicenseLookupComponent,
        data: { headerTitle: 'License Lookup' },
      },
      {
        path: 'admins',
        component: PlatformAdminsListComponent,
        data: { headerTitle: 'Platform Admins' },
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
